import { useTranslation } from "react-i18next";
import { useEffect } from "react";
import { LaunchPage, MessageTooltip, Spacer } from "@qivia/ui";
import { useAppDispatch, useAppSelector } from "../../../../redux/hooks";
import {
  loadCompanyPortalUrlAsync,
  selectCompanyPortalUrlStatus,
} from "../billingsSlice";
import { selectCompany } from "../../homeSlice";
import styled from "styled-components";
import { useParams } from "react-router-dom";
import { EmailsFrame } from "../archives/statementsTab";

export const BillingCompanyPortal = (props: {
  companyPortalUrl: URL | null;
}) => {
  const { t } = useTranslation();
  const params = useParams();
  const dispatch = useAppDispatch();
  const company = useAppSelector(selectCompany);
  const companyPortalUrlStatus = useAppSelector(selectCompanyPortalUrlStatus);

  useEffect(() => {
    if (company && companyPortalUrlStatus === "idle") {
      void dispatch(loadCompanyPortalUrlAsync(company?.uuid));
    }
  }, [company, companyPortalUrlStatus, dispatch]);

  if (params.tab !== "portal") {
    return;
  }

  if (!props.companyPortalUrl || !company) {
    return;
  }

  if (companyPortalUrlStatus === "processing") {
    return <LaunchPage />;
  }

  props.companyPortalUrl.searchParams.set("hideSidebar", "true");
  const portalUrlStringify = props.companyPortalUrl.toString();

  return (
    <StyledCustomPortalSection>
      <Spacer y={0.5} />
      <MessageTooltip
        title={t("billings.portal.messageTooltip.title")}
        text={t(`billings.portal.messageTooltip.text`)}
        type="INFORMATIVE"
      />
      <Spacer y={1} />
      <EmailsFrame company={company} />
      <Spacer y={2} />
      <StyledPortalIframeContainer>
        <iframe title={t("billings.portal.link")} src={portalUrlStringify} />
      </StyledPortalIframeContainer>
    </StyledCustomPortalSection>
  );
};

const StyledPortalIframeContainer = styled.div`
  iframe {
    border-radius: 0.5rem;
    border: none; 
    width: 100%;
    min-height: 35rem;
  },
`;

const StyledCustomPortalSection = styled.div`
  border-radius: 0.5rem;
`;
